import { NEW_PURCHASE_COMPLETED, BUY_AGAIN_COMPLETED, CHECK_STATUS_COMPLETED } from "../actions/actions";

const initialState = [];

function AirtimeTokenReducer(txData = initialState,action) {
    
    const {type, payload} = action;

    return [...txData, payload];

}

export default AirtimeTokenReducer;